import React from 'react';
import { motion } from 'framer-motion';
import { Palmtree, X } from 'lucide-react';

interface VacationConfirmDialogProps {
  onConfirm: () => void;
  onCancel: () => void;
}

export function VacationConfirmDialog({ onConfirm, onCancel }: VacationConfirmDialogProps) {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="fixed inset-0 bg-background/80 backdrop-blur-sm flex items-center justify-center z-50 pt-32"
    >
      <div className="theme-card p-4 max-w-xs mx-4 relative overflow-hidden">
        <div className="absolute top-0 right-0 w-24 h-24 opacity-10">
          <div className="absolute inset-0 bg-gradient-to-br from-primary to-transparent rounded-full blur-2xl" />
        </div>
        
        <div className="relative">
          <div className="flex items-center justify-between mb-3">
            <div className="flex items-center gap-2">
              <div className="relative">
                <Palmtree className="w-5 h-5 text-primary" />
                <div className="absolute inset-0 bg-primary/20 blur-xl rounded-full" />
              </div>
              <h2 className="text-base font-medium">Time for a Break?</h2>
            </div>
            <button 
              onClick={onCancel}
              className="text-muted-foreground hover:text-foreground transition-colors"
            >
              <X className="w-4 h-4" />
            </button>
          </div>

          <p className="text-xs text-muted-foreground mb-4">
            Ready to chill? Vacation mode hides your strain, sleep, and recovery stats from the main view (but they're still lurking around in other spots 👀).
          </p>

          <div className="flex gap-2">
            <button
              onClick={onConfirm}
              className="flex-1 theme-button px-3 py-1.5 rounded-lg text-xs relative group overflow-hidden"
            >
              <div className="absolute inset-0 bg-gradient-to-r from-primary via-purple-500 to-primary opacity-0 group-hover:opacity-20 transition-opacity" />
              <span className="relative">Let's Go! ✨</span>
            </button>
            <button
              onClick={onCancel}
              className="flex-1 bg-muted text-muted-foreground hover:bg-muted/70 px-3 py-1.5 rounded-lg text-xs transition-colors"
            >
              Not Yet
            </button>
          </div>
        </div>
      </div>
    </motion.div>
  );
}